const baseStyle = {}

const defaultProps = {
  size: 'md',
  variant: 'primary',
}

const sizes = {
  sm: {
    container: {
      minH: '4px',
    },
    percentage: {
      fontSize: '80%',
      top: '-16px',
    },
  },
  md: {
    container: {
      minH: '8px',
    },
    percentage: {
      fontSize: '100%',
      top: '-20px',
    },
  },
  lg: {
    container: {
      minH: '12px',
    },
    percentage: {
      fontSize: '110%',
      top: '-22px',
    },
  },
  xl: {
    container: {
      minH: '16px',
    },
    percentage: {
      fontSize: '120%',
      top: '-24px',
    },
  },
}

const variants = {
  primary: {
    bg: 'darkBlue.95',
    color: 'darkBlue.main',
  },
  green: {
    bg: 'landGreen.95',
    color: 'landGreen.main',
  },
  red: {
    bg: 'energyRed.95',
    color: 'energyRed.main',
  },
}

export default {
  baseStyle,
  defaultProps,
  sizes,
  variants,
}
